// extracted by mini-css-extract-plugin
export default {"logEntriesList":"LogEntriesList_logEntriesList__4S2Jy","logEntryItem":"LogEntriesList_logEntryItem__ZyTDB"};